import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ResponsiveContainer, ResponsiveContent } from '../ui/ResponsiveLayout';
import BrandSymbol from '../ui/BrandSymbol';

const BeneficiaryComingSoon: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const ownerName = location.state?.ownerName || 'the estate owner';

  return (
    <ResponsiveContainer background="stone">
      <ResponsiveContent>
        <div className="max-w-3xl mx-auto py-2">
          <div className="flex flex-col items-center justify-center mb-2 w-full">
            <BrandSymbol size="4xl" variant="dark" showText={true} className="mb-6" />
          </div>

          <div className="bg-white rounded-2xl shadow-lg border border-stone-200 overflow-hidden">
            <div className="bg-gradient-to-r from-cyan-700 to-cyan-600 px-8 py-6 text-center">
              <h1 className="text-2xl md:text-3xl font-display font-semibold text-white">
                Coming Soon!
              </h1>
            </div>

            <div className="px-8 py-10">
              <p className="text-lg text-stone-700 text-center mb-8 leading-relaxed max-w-2xl mx-auto">
                We&apos;re currently building a <span className="font-semibold text-cyan-700">Beneficiary Portal</span> that will
                allow you to securely view important updates and information related to <span className="font-semibold">{ownerName}&apos;s</span>{' '}
                End of an Era plan when the time comes.
              </p>

              <div className="bg-stone-50 border border-stone-200 rounded-xl p-5 mb-8 max-w-2xl mx-auto">
                <p className="text-stone-700 font-medium mb-3">Once available, the portal will provide a clear place for beneficiaries to:</p>
                <ul className="list-disc pl-6 space-y-2 text-stone-600">
                  <li>View information about assets or gifts intended for them</li>
                  <li>Receive updates during the estate settlement process</li>
                  <li>Access documents or instructions shared by the executor</li>
                </ul>
                <p className="text-stone-700 mt-4">
                  You&apos;ll receive a separate email with access details once the portal is ready.
                </p>
              </div>

              <div className="flex justify-center mb-10">
                <div className="bg-stone-50 rounded-xl border border-stone-200 p-4 max-w-2xl w-full">
                  <img
                    src="/images/beneficiary-portal-preview.png"
                    alt="Beneficiary Portal Preview"
                    className="w-full rounded-lg shadow-sm"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      target.parentElement!.innerHTML = `
                        <div class="bg-gradient-to-br from-stone-100 to-stone-200 rounded-lg p-12 text-center">
                          <svg class="w-24 h-24 text-stone-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7a4 4 0 01-8 0M12 14v7m-7-3a7 7 0 0114 0" />
                          </svg>
                          <p class="text-stone-500 font-medium">Beneficiary Portal Dashboard</p>
                          <p class="text-stone-400 text-sm mt-1">Preview coming soon</p>
                        </div>
                      `;
                    }}
                  />
                </div>
              </div>

              <div className="flex items-center gap-4 mb-8">
                <div className="flex-1 h-px bg-stone-200"></div>
                <span className="text-sm text-stone-400">In the meantime</span>
                <div className="flex-1 h-px bg-stone-200"></div>
              </div>

              <div className="text-center">
                <p className="text-stone-600 mb-4">
                  Feel free to use our estate planner to organize your own legacy.
                </p>
                <button
                  onClick={() => navigate('/frame-140')}
                  className="inline-flex items-center gap-2 px-8 py-3 bg-cyan-700 text-white rounded-lg font-medium hover:bg-cyan-800 transition-colors shadow-sm"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                  Go to My Estate Planner
                </button>
              </div>
            </div>

            <div className="bg-stone-50 px-8 py-4 border-t border-stone-200">
              <div className="flex items-center justify-between">
                <button
                  onClick={() => navigate('/estate-selector')}
                  className="text-sm text-stone-500 hover:text-cyan-700 flex items-center gap-1"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                  Back to Estate Selection
                </button>
                {/* Removed Settings button */}
              </div>
            </div>
          </div>

          <p className="text-center text-sm text-stone-500 mt-6">
            Questions? <a href="mailto:support@endofanera.ai" className="text-cyan-700 hover:underline">Contact Support</a>
          </p>
        </div>
      </ResponsiveContent>
    </ResponsiveContainer>
  );
};

export default BeneficiaryComingSoon;
